var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgAlertCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 8.33337V13M12.9999 17.6667H13.0116M24.6666 13C24.6666 19.4434 19.4432 24.6667 12.9999 24.6667C6.5566 24.6667 1.33325 19.4434 1.33325 13C1.33325 6.55672 6.5566 1.33337 12.9999 1.33337C19.4432 1.33337 24.6666 6.55672 24.6666 13Z",
    stroke: "currentColor",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAlertCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/alert-circle.3f1adf40.svg";
export { ForwardRef as ReactComponent };